import React from "react"
import { Link } from "gatsby"
import Edit from "../../../../images/edit.svg"
import Loader from "../../../Loader"

const Summary = (props) => {
  let {
    bn_rc_number,
    tin,
    business_name,
    new_phone,
    new_email,
    certificate_of_registration_name,
  } = props.data

  return (
    <div className="container summary">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <h2 className="sparkle--title sparkle-deep-blue my-5">Summary</h2>

          <div className="business-suport-card my-lg-5 waitlist__form p-lg-5">
            <div className="row position-relative">
              <div className="col-lg-4 my-3">
                <p className="mb-1 title">Value Added Service</p>
                <p className="description">TIN Correction</p>
              </div>

              <button
                className="btn primary-color edit-button"
                onClick={() => props.setShowSummary(false)}
              >
                <img src={Edit} alt="Edit" className="mr-2 mb-1" />
                Edit
              </button>
            </div>

            <div className="row">
              <div className="col-lg-4 my-3">
                <p className="mb-1 title">Business Name</p>
                <p className="description">{business_name}</p>
              </div>

              <div className="col-lg-4 my-3 offset-lg-1">
                <p className="mb-1 title">BN/RC Number</p>
                <p className="description">{bn_rc_number}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 my-3">
                <p className="mb-1 title">Tax Identification Number</p>
                <p className="description">{tin}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 my-3">
                <p className="mb-1 title">New Email Address</p>
                <p className="description">{new_email}</p>
              </div>

              <div className="col-lg-4 my-3 offset-lg-1">
                <p className="mb-1 title">New Phone Number</p>
                <p className="description">{new_phone}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 my-3">
                <p className="mb-1 title">Additional Documents</p>

                <p className="description text-break">
                  {certificate_of_registration_name}
                </p>
              </div>
            </div>

            <div className="row my-5">
              <div className="col-lg-5">
                <Link
                  to="/business-support/get-started"
                  className="btn sparkle--button__green_outline px-5 btn-block"
                >
                  Cancel
                </Link>
              </div>

              <div className="col-lg-6">
                <button
                  className="btn sparkle--button__green px-4 btn-block"
                  onClick={props.payFee}
                  disabled={props.loadingStatus}
                >
                  {!props.loadingStatus ? (
                    "Make Payment of ₦ 5,000.00"
                  ) : (
                    <>
                      <Loader width="30" color="#fff" />
                    </>
                  )}
                </button>
              </div>
            </div>

            <p className="sparkle-bright-orange text-center">
              {props.loadingStatus && "Application is in progress..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Summary
